import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ActionButton } from "../../components/controls";
import 'date-fns';
import { Backdrop, Box, Card, CircularProgress, Container, IconButton, InputAdornment, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable, { MTableToolbar } from 'material-table'
import { EmailGroupService } from "../../services";
import TableIcons from '../../materialTableIcons';
import { Magnify } from "mdi-material-ui";
import '../GridStyleOverrides/materialTableHome.css'
import { SET_FORM_DATA_FROM_TABLE_EMAIL_GROUP, SET_IS_EDITING_EMAIL_GROUP, SET_IS_CREATING_EMAIL_GROUP, SET_ALL_EMAIL_GROUPS } from '../../actions/types';

//Many of these stylings aren't being used, Material Table doesn't handle classNames
const useStyles = makeStyles((theme) => ({
    textInput: {
        '& label.Mui-focused': {
            color: theme.palette.text.primary,
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#86C1D4',
            },
            '&:hover fieldset': {
                borderColor: theme.palette.text.primary,
            },
            '&.Mui-focused fieldset': {
                borderColor: theme.palette.text.primary,
            },
        },
    },
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
        marginLeft: 10,
        marginRight: 20,
        paddingRight: 30
    },
    cardFiltersContainer: {
        marginTop: 20,
        backgroundColor: theme.palette.background.paper
    },
    cardContentForFiltersContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        backgroundColor: theme.palette.background.paper
    },
    filterDropdownsContainer: {
        minWidth: '80%',
    },
    gridItem: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
    },
    showAllAndFilterButtonsContainer: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 20,
    },
    showAllButton: {
        width: 140,
        marginBottom: 8,
    },
    filterButton: {
        width: 140,
        marginTop: 8,
    },
    card: {
        display: 'block',
        marginTop: 20,
        marginBottom: 30,
        paddingTop: 20,
        paddingLeft: 0,
        paddingRight: 0,
        backgroundColor: theme.palette.background.paper,
    },
    inputGridContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        marginBottom: 0,
        justifyContent: 'space-between'
    },
    exportButton: {
        width: 140,
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 20
    },
    searchButton: {
        width: 180,
        fontWeight: 'bold',
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 20
    },
    inputLabel: {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: '1rem',
        marginRight: '1rem',
        color: theme.palette.text.secondary,
        width: '4rem',
        fontSize: 16,
        zIndex: 1000,
        lineHeight: 1.75,
        fontWeight: 'bold',
    },
    textField: {
        width: 220,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    createNewButton: {
        marginLeft: 20,
    },
    tableHeader: {
        backgroundColor: '#86C1D4'
    },
    tankMidnightTable: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 650,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 20,
        '& .MuiDataGrid-colCellWrapper': {
            backgroundColor: '#86C1D4'
        },
        '& .MuiDataGrid-colCellTitle': {
            fontWeight: 700,
            color: theme.palette.background.paper,
            backgroundColor: '#86C1D4'
        },
        '& .MuiDataGrid-colCellSortable': {
            backgroundColor: '#86C1D4'
        },
        '& .MuiDataGrid-columnSeparator': {

        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
}));

const headerStyle = {
    backgroundColor: '#86C1D4',
    color: 'white',
    height: 49,
    textTransform: 'uppercase',
    textAlign: 'left'
}
const rowStyle = {
    maxHeight: 50,
}

export default function EmailGroupHome() {

    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    const [isTableLoading, setIsTableLoading] = useState(true);

    const [dataSource, setDataSource] = useState([]);
    const [dataForTable, setDataForTable] = useState([]);
    const [freeSearchValue, setFreeSearchValue] = useState('');

    //APPLY FILTERS/SEARCH
    useEffect(() => {
        if (dataSource) {
        let data = [...dataSource];
            if (freeSearchValue) {
                let query = freeSearchValue.toLowerCase().trim();
                let applySearch = dataSource.filter((item) => {
                    return (
                        item.mailGroup?.toLowerCase().indexOf(query) >= 0 ||
                        item.email?.toLowerCase().indexOf(query) >= 0 ||
                        item.sloc?.toLowerCase().indexOf(query) >= 0
                    )
                })
                data = applySearch
            }
            setDataForTable([...data])
        }
    }, [dataSource, freeSearchValue])

    useEffect(() => {
        async function fetchEmailGroups() {
            let data = await EmailGroupService.getEmailGroups();
            setDataSource(data);
            setIsTableLoading(false);
        }
        fetchEmailGroups()
    }, []);

    const handleFreeSearchChange = (event) => {
        setFreeSearchValue(event.target.value)
        //string
    };

    const columnDefs = [
        {
            title: '#',
            field: 'custom',
            cellStyle: { width: 100, minWidth: 100, maxWidth: 100, paddingLeft: 50 },
            headerStyle: { paddingLeft: 50 },
            render: rowData => rowData.tableData.id + 1
        },
        {
            title: 'Group Name',
            field: 'mailGroup',
            cellStyle: { width: 200, minWidth: 200, maxWidth: 200 }
        },
        {
            title: 'Sloc',
            field: 'sloc',
            cellStyle: { width: 100, minWidth: 100, maxWidth: 100 }
        },
        //{
        //    title: 'Email Addresses',
        //    field: 'email',
        //    cellStyle: { width: 500, minWidth: 300, maxWidth: 500 }
        //},

    ]

    return (
        <>
            <Container>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        Email Groups
                    </h2>
                </div>
                <Card className={classes.card}>
                    <div className={classes.actions}>
                        <ActionButton text='Create New' className={classes.createNewButton} onClick={() => {

                            //get max + 1 for new ID
                            let nums = dataSource.map(x => Number(x.id))
                            let next = Math.max(...nums) + 1

                            dispatch({
                                type: SET_IS_CREATING_EMAIL_GROUP,
                                payload: true,
                            });
                            dispatch({
                                type: SET_IS_EDITING_EMAIL_GROUP,
                                payload: false,
                            });
                            dispatch({
                                type: SET_FORM_DATA_FROM_TABLE_EMAIL_GROUP,
                                payload: {
                                    id: next,
                                    mailGroup: "",
                                    email: "",
                                }
                            })
                            dispatch({
                                type: SET_ALL_EMAIL_GROUPS,
                                payload: dataSource
                            })
                            history.push('/admin/email-group/manage')
                        }
                        } />
                        <TextField
                            id="search"
                            name="search"
                            variant='outlined'
                            size='small'
                            style={{ width: '40rem', marginLeft: 30 }}
                            label='Type to filter results...'
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end">
                                        <IconButton disabled={true}>
                                            <Magnify />
                                        </IconButton>
                                    </InputAdornment>
                            }}
                            disabled={dataSource?.length === 0}
                            value={freeSearchValue}
                            onChange={(event) => {
                                handleFreeSearchChange(event);
                            }}
                        />
                    </div>
                    <Box px={1.5} className={classes.tankMidnightTable}>
                        <MaterialTable
                            className={'emailTable'}
                            style={{ width: '100%', boxShadow: 'none' }}
                            icons={TableIcons}
                            columns={columnDefs}
                            data={dataForTable}
                            title=""
                            components={{
                                Toolbar: props => (
                                    <div style={{ width: 0, height: 0 }}>
                                        <MTableToolbar {...props} />
                                    </div>
                                ),
                            }}
                            localization={{
                                header: {
                                    actions: 'Manage'
                                }
                            }}
                            options={{
                                actionsCellStyle: { justifyContent: 'center'},
                                actionsColumnIndex: -1,
                                filtering: false,
                                search: false,
                                sorting: true,
                                headerStyle: headerStyle,
                                rowStyle: rowStyle,
                                maxBodyHeight: '600px',
                                showTitle: false,
                                toolbar: false,
                                paging: true,
                                pageSize: 10,
                                emptyRowsWhenPaging: true,
                                pageSizeOptions: [10, 20, 50],
                            }}
                            actions={[
                                {
                                    icon: () => <TableIcons.Edit />,
                                    tooltip: 'Edit Email Group',
                                    onClick: (event, rowData) => {
                                        dispatch({
                                            type: SET_FORM_DATA_FROM_TABLE_EMAIL_GROUP,
                                            payload: { ...rowData },
                                        });
                                        dispatch({
                                            type: SET_IS_CREATING_EMAIL_GROUP,
                                            payload: false,
                                        });
                                        dispatch({
                                            type: SET_IS_EDITING_EMAIL_GROUP,
                                            payload: true,
                                        });
                                        dispatch({
                                            type: SET_ALL_EMAIL_GROUPS,
                                            payload: dataSource
                                        })
                                        history.push('/admin/email-group/manage')
                                    }
                                }
                            ]}
                        />
                    </Box>
                </Card>
            </Container >
            <Backdrop className={classes.backdrop} open={isTableLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}